export default "__VITE_ASSET__D$XT0jfE__"